import { Injectable } from '@angular/core';
import { ServiceApi } from '../genericApi/service-api';
import { ConfigModel } from '../../Core/Config/models/config.model';
import { ConfigService } from '../../Core/Config/services/config.service';
import { Observable } from 'rxjs';
import { InteractionApiModel } from './model/interaction-api.model';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';



@Injectable()
export class InteractionViewApi {
    private apiUrl: string;

    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService
    ) {
        const config: ConfigModel = this.configurationService.getConfig();

        this.apiUrl = config.apiUrl;
    }

    public createInteraction(interaction: InteractionApiModel): Observable<void> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<void>(
            '/interactions/',
            interaction,
            HttpVerbsEnum.POST
        );
    }

    public updateInteraction(interactionId: string, interaction: InteractionApiModel): Observable<void> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<void>(
            `/interactions/${interactionId}`,
            interaction,
            HttpVerbsEnum.PUT
        );
    }

    public deleteInteraction(interactionId: string): Observable<void> {
        this.serviceApi.apiUrl = this.apiUrl;

        return this.serviceApi.api<void>(
            `/interactions/${interactionId}`,
            null,
            HttpVerbsEnum.DELETE
        );
    }
}
